import axios from "axios";
import store from "store";

const token = store?.getState()?.auth?.token ?? "";
axios.defaults.headers.common.Authorization = `Bearer ${token}`;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error.response.status);
    if (error.response.status === 403 || error.response.status === 401) {
      store.dispatch("RESET_AUTH");
    }
    return Promise.reject(error);
  }
);

export default axios;
